<template>
  <div class="col-7">
    <el-card>
      <h4>Contracting Party</h4>
      <base-input label="Client Type">
        <el-select v-model="Order.clientType" class="select-primary" filterable size="large" placeholder="Client Type"
          :disabled="disabled" style="width: 45%" :class="{ 'is-error': !OrderRules.clientType.validation }">
          <el-option class="select-primary" v-for="ctoptinal in useOrder.ClientTypeOptionals"
            :key="'ctoptional' + ctoptinal" :value="ctoptinal.value" :label="ctoptinal.label"></el-option>
        </el-select>
      </base-input>
      <!-- <div class="contracting-party">
        Advertiser
        <el-icon class="star-icon">
          <star-filled />
        </el-icon>
        <span class="text-red ctrParty" v-if="Order.clientType === 'DC'"
          >[Contracting Party]</span
        >
      </div> -->
      <!-- <div
        style="
          display: flex;
          margin-left: 64%;
          justify-content: space-between;
          position: absolute;
          z-index: 99;
          margin-bottom: 60px;
        "
      >
        <base-button
          size="sm"
          type="primary"
          style="width: 140px; 
          margin-bottom: 40px;
          font-size: 12px; padding: 6px 14.5px"
        >
          <el-icon style="margin-right: 6px">
            <Plus />
          </el-icon>
          New Company
        </base-button>
      </div> -->
      <div style="display: flex" class="input-with-check-box" :class="{
        'contracting-party': Order.clientType === 'DC',
      }">
        <base-input style="width: 75%" :required="true" label="Advertiser">
          <el-select v-model="Order.advertiserCode" placeholder="Advertiser" class="select-primary" size="large"
            style="width: 100%" filterable clearable @change="useOrder.changeAdvertiser(true)" ref="advertiserRef"
            @focus="useOrder.focusAdvertiser" :disabled="disabled"
            :class="{ 'is-error': !OrderRules.advertiserCode.validation }">
            <el-option class="select-primary" v-for="adoptional in useOrder.AdvertiserOptionals" :key="adoptional.value"
              :value="adoptional.value" :label="adoptional.label"></el-option>
          </el-select>
          <div style="display: flex">
            <span class="sub-info" style="margin-left: auto" v-if="Order.businessNature"><span class="dot"></span> {{
              Order.businessNature }}</span>
            <span class="sub-info" v-if="Order.isClientKeyAcc"><span class="dot"></span>key Acc.</span>
            <span class="sub-info" v-if="Order.isClientBR">
              <span v-if="new Date(Order.clientBRExpired) >= new Date() ||
                Order.clientType === 'AG'
                ">
                <span class="dot"></span>BR
                {{ formatter_date(Order.clientBRExpired) }}</span>
              <span v-else-if="Order.clientType === 'DC'" style="color: red">
                BR
                {{ formatter_date(Order.clientBRExpired) }}</span>
            </span>
            <span class="sub-info" v-if="(Order.clientType === 'DC' || Order.clientType === 'P') &&
              Order.advertiserCode &&
              Order.isClientBR == false
              " style="color: red; font-weight: 700">NO BR
            </span>
            <span class="sub-info" v-if="Order.isClientTax"><span class="dot"></span>Tax 88</span>
          </div>
        </base-input>
        <base-checkbox style="width: 150px" v-model="Order.isNewClient" :disabled="disabled">New Client</base-checkbox>
        <div style="margin-left: -290px; margin-top: -10px" v-if="Order.status !== 'Completed'">
          <base-button size="sm" type="primary" v-if="useOrder.getOrderFunctionPermission('NewCompanyOrContact')?.enable
            " :disabled="useOrder.getOrderFunctionPermission('NewCompanyOrContact')
    ?.disable
    " @click="linkToCompany" style="width: 140px; font-size: 12px; padding: 6px 14.5px">
            <el-icon style="margin-right: 6px">
              <Plus />
            </el-icon>
            New Company
          </base-button>
        </div>
      </div>

      <div style="display: flex; position: relative; top: -20px" v-if="!Order.isClientPermission">
        <span style="color: rgb(196, 51, 55); font-size: 11px">
          Salesman has no permission
        </span>
      </div>
      <div style="display: flex" class="input-with-check-box" :class="{
        'contracting-party': Order.clientType === 'AG',
      }" v-if="Order.clientType === 'AG'">
        <base-input style="width: 75%" :required="true" label="Agency">
          <el-select class="select-primary" size="large" v-model="Order.agencyCode" style="width: 100%" filterable
            clearable placeholder="Agency" @change="useOrder.changeAgency" ref="agencyRef" @focus="useOrder.focusAgency"
            :disabled="disabled || (Order.clientType ?? '') !== 'AG'"
            :class="{ 'is-error': !OrderRules.agencyCode.validation }">
            <el-option class="select-primary" v-for="adoptional in useOrder.AgencyList" :key="adoptional.value"
              :label="adoptional.label" :value="adoptional.value"></el-option>
          </el-select>
          <div style="display: flex">
            <span class="sub-info" style="margin-left: auto" v-if="Order.agencyType"><span class="dot"></span>{{
              Order.agencyType }}</span>
            <span class="sub-info" v-if="Order.isAgencyBR">
              <span v-if="new Date(Order.agencyBRExpired) >= new Date()">
                <span class="dot"></span>BR
                {{ formatter_date(Order.agencyBRExpired) }}</span>
              <span v-else style="color: red">
                BR
                {{ formatter_date(Order.agencyBRExpired) }}</span>
            </span>
            <span class="sub-info" v-if="Order.clientType === 'AG' &&
              Order.agencyCode &&
              Order.isAgencyBR == false
              " style="color: red; font-weight: 700">NO BR
            </span>
          </div>
        </base-input>
        <base-checkbox style="width: 150px" :disabled="disabled || (Order.clientType ?? '') !== 'AG'"
          v-model="Order.isAgencyDiscount" @change="changeAgencyDiscount">Agency Discount</base-checkbox>
      </div>

      <div style="display: flex" class="input-with-check-box" v-if="Order.agencyType === 'ITC'">
        <base-input style="width: 75%" label="Referral">
          <el-select class="select-primary" size="large" v-model="Order.referralCode" @change="useOrder.changeReferral"
            @focus="useOrder.changeReferral" style="width: 100%" filterable clearable placeholder="Referral"
            ref="referralRef" :disabled="disabled || (Order.clientType ?? '') !== 'AG'">
            <el-option class="select-primary" v-for="adoptional in useOrder.AdvertiserOptionalsAG" :key="adoptional.value"
              :label="adoptional.label" :value="adoptional.value"></el-option>
          </el-select>
        </base-input>
      </div>

      <div style="display: flex">
        <base-input label="Address Name" style="width: 75%" :required="Order.clientType != 'P'">
          <el-select class="select-primary" size="large" style="width: 100%" ref="billNameRef" v-model="Order.billNameId"
            placeholder="Address Name" filterable @change="useOrder.changeBillName" @focus="useOrder.changeBillName"
            :disabled="disabled" :class="{ 'is-error': !OrderRules.billName.validation }">
            <el-option class="select-primary" v-for="bnoptional in useOrder.BillNameOptionals"
              :key="'bnoptional' + bnoptional" :label="bnoptional.label" :value="bnoptional.id"></el-option>
          </el-select>
        </base-input>
      </div>
      <span>Address</span>
      <div>
        <base-input style="width: 75%">
          <el-input label="Address" type="textarea" v-model="Order.billAddress" :rows="3" disabled class="address">
          </el-input>
        </base-input>
      </div>
    </el-card>
  </div>
  <div class="col-sm-5">
    <el-card>
      <h4>Business Category</h4>
      <div style="display: flex">
        <base-input label="" style="width: 100%" :required="true">
          <el-select v-model="useOrder.OrderBusinessCategoryIds" placeholder="Business Category" size="large"
            class="select-primary" multiple filterable :persistent="true" :reserve-keyword="false" :disabled="disabled"
            ref="CategoryRef" @change="changeOrderBusinessCategory" @blur="CategoryBlur">
            <el-option v-for="category in useOrder.BusinessOptions" :key="category.id"
              :label="category.code + ' - ' + category.name" :value="category.id">
            </el-option>
          </el-select>
        </base-input>
      </div>
    </el-card>
    <el-card class="card-contact-person">
      <div style="display: flex; position: relative" class="sales-title">
        <div style="
            position: absolute;
            width: 100%;
            display: flex;
            justify-content: center;
            visibility: hidden;
          " ref="buttonRef">
          控制popover
        </div>
        <h4>Contact Person</h4>
        <h4 class="sub">
          <div class="div-contact-person">
            <el-button link :underline="false" :disabled="disabled" @click="onClickOutside" class="btn-contact-person">
              <el-icon class="icon-user-add btn-contact-person-icon text-primary matrix-icon-user-add"></el-icon>
              <!-- <el-icon class="icon-user-add btn-contact-person-icon">
                <svg-icon iconClass="user_add"></svg-icon
              ></el-icon> -->
              <span style="font-size: 12px; color: #3182ce" class="btn-contact-person-text">
                Add Contact Person</span>
            </el-button>
          </div>
        </h4>
        <h4 style="order: 3" class="sub" v-if="Order.status !== 'Completed'">
          <base-button @click="linkToContact" type="primary" size="sm" style="width: 130px; font-size: 12px"
            class="btn-order" v-if="useOrder.getOrderFunctionPermission('NewCompanyOrContact')?.enable
              " :disabled="useOrder.getOrderFunctionPermission('NewCompanyOrContact')
    ?.disable
    ">
            <el-icon style="margin-right: 9px">
              <Plus />
            </el-icon>
            New Contact</base-button>
        </h4>
        <hr />
      </div>
      <div id="contactperson">
        <el-table :data="ContactPersons" style="width: 100%" border v-if="ContactPersons.length > 0">
          <el-table-column width="51">
            <template #default="scope">
              <div :id="scope.row.ContactPerson" v-if="!disabled">
                <el-button type="text" class="operation-icon danger" @click="removecontact(scope.$index)" v-if="!disabled"
                  :size="28">
                  <el-icon>
                    <CircleClose />
                  </el-icon>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Contact Person" width="180">
            <template #default="scope">
              <div>
                {{ scope.row.name }}&nbsp;<span v-if="scope.row.title != null && scope.row.title != ''">({{
                  scope.row.title }})</span>
              </div>
              <!-- <div style="display: flex">
                <div style="width: 50%">Tel.: {{ scope.row.phone }}</div>
                <div style="width: 50%">Fax: {{ scope.row.fax }}</div>
              </div> -->
              <div>Tel.: {{ scope.row.phone }}</div>
              <div>Fax: {{ scope.row.fax }}</div>
              <!-- <div>Mobile: {{ scope.row.mobile }}</div> -->
            </template>
          </el-table-column>
          <el-table-column prop="email" label="Email"></el-table-column>
          <el-table-column prop="owner" label="Owner" width="120"></el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
  <!-- Order Contact Popover -->
  <div>
    <el-popover ref="popoverRef" placement="bottom" trigger="click" :virtual-ref="buttonRef" :visible="visible"
      virtual-triggering persistent :disabled="disabled" :width="700" @before-enter="BeforeEnterContact"
      @show="changePopCss">
      <div class="choose_contact" :style="'width:100%;height:300px'">
        <choosecontact @close="closeContact" @confirm="addContactPersons" :is-enable="visible" />
      </div>
    </el-popover>
  </div>
</template>

<script setup>
import {
  StarFilled,
  Check,
  Plus,
  CircleClose,
  CirclePlusFilled,
} from '@element-plus/icons-vue';
import { ref, unref, watch, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
import { ClickOutside as vClickOutside } from 'element-plus';
import booknet from '@/network/booknet';
import { formatter_date } from '@/assets/js/formatter';
import '@/views/order/css/index.css';
import './css/index.css';
import { useOrderStore } from '@/store/order';
import { useAuthorityStore } from '@/store/authority';
import { storeToRefs } from 'pinia';
import $ from 'jquery';

// components
import choosecontact from '@/views/order/contractparty/choosecontact';

const messageConfig = require('@/models/messageConfig.js');
const visible = ref(false);
// use Order
const useOrder = useOrderStore();
const { Order, OrderRules, ContactPersons, disabled, bHasIntlSplit, crmUrl } =
  storeToRefs(useOrder);

// #region data
// const AgencyDiscount = ref(15);

// const popoverwidth = ref(0);
const buttonRef = ref();
const popoverRef = ref();
const CategoryRef = ref();

var auth = useAuthorityStore();
//Salesman/TeamHead角色判断是否有权限 => 为了清洗点 改为isSales
const isSales = auth.bHasRole('BBSalesman') || auth.bHasRole('BBTeamHead');

const billNameRef = ref();
const agencyRef = ref();
const advertiserRef = ref();

onMounted(() => {
  //显示保存的数据,防止CRM数据修改后显示最新的
  billNameRef.value.selectedLabel = useOrder.Order.billName;
  if (Order.clientType === 'AG') {
    agencyRef.value.selectedLabel = useOrder.Order.agencyName;
  }
  advertiserRef.value.selectedLabel = useOrder.Order.advertiserName;
  if (useOrder.BusinessCategories.length > 0) {
    CategoryRef.value.selected = [
      {
        currentLabel:
          useOrder.BusinessCategories[0].code +
          ' - ' +
          useOrder.BusinessCategories[0].name,
      },
    ];
  }
});
// #endregion
//监听值变化
watch(
  () => useOrder.Order.clientType,
  (newValue, oldValue) => {
    // 由於AG轉DC/P   或 DC/P轉AG都會影響Agency Discount
    if (
      bHasIntlSplit.value == true &&
      newValue == 'AG' &&
      (oldValue == 'DC' || oldValue == 'P')
    ) {
      //弹窗提示
      ElMessageBox.alert(
        'Please double check and modify Internal Split as agency discount has changed.',
        'Warning',
        {
          confirmButtonText: 'OK',
          type: 'warning',
        }
      );
    } else if (
      bHasIntlSplit.value == true &&
      oldValue == 'AG' &&
      (newValue == 'DC' || newValue == 'P') &&
      Order.value.isAgencyDiscount == true
    ) {
      //弹窗提示
      ElMessageBox.alert(
        'Please double check and modify Internal Split as agency discount has changed.',
        'Warning',
        {
          confirmButtonText: 'OK',
          type: 'warning',
        }
      );
    }

    //ClientType变更,传旧值处理
    useOrder.changeClientType(oldValue);
  }
);

// 点击New Company按钮
const newcompanyclick = () => {
  ElMessage({
    message: '正在努力开发中..',
    type: 'warning',
  });
};
//添加contact
const addcontact = () => {
  ElMessage({
    message: '正在努力开发中..',
    type: 'warning',
  });
};

//移除contact
const removecontact = async (index) => {
  // if (ContactPersons.value[index].id !== 0) {
  var result = await ElMessageBox.confirm(
    'Do you want to delete?',
    'Delete Contact',
    {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).catch(() => { });
  if (result != 'confirm') {
    return;
  }
  // }

  useOrder.deleteContactPerson(index);
};

// 变更Client
// const changeAdvertiser = async () => {
//   // Order.value.agencyCode = "";

//   // BusinessCategories.value = [];
//   // useOrder.OrderBusinessCategoryIds = [];
//   // useOrder.ProductCategoryList = [];

//   // if (Order.value.clientType === "DC") {
//   //   Order.value.billName = "";
//   // }

//   await useOrder.changeAdvertiser(true);
// };

// #region Change

// changeAgencyDisounct Confirm
const changeAgencyDiscount = () => {
  if (bHasIntlSplit.value) {
    //弹窗提示
    ElMessageBox.alert(
      'Please double check and modify Internal Split as agency discount has changed.',
      'Warning',
      {
        confirmButtonText: 'OK',
        type: 'warning',
      }
    );

    // 更新Internal Split AC
    booknet.ReCalculateInternalSplit(
      Order.value.id,
      Order.value.isAgencyDiscount,
      Order.value.agencyDiscount
    );
  }

  Order.value.agencyDiscount = Order.value.isAgencyDiscount ? 15 : 0;
};
// #endregion

const BeforeEnterContact = () => {
  //   // visible.value = true;
  //   // console.log(visible,visible);
  // // setTimeout(() => {
  //   // 方法区
  //   // // 计算宽度
  //   // popoverwidth.value =
  //   //   document.getElementById("contactperson").clientWidth - 20 - 24;
  //   // 更新状态
  //   const checkeds =
  //     ContactPersons.value
  //       .filter((t) => t.status !== "Inactive")
  //       ?.map((t) => t.code) || [];
  //   useOrder.ContactOptionals.map((t) => {
  //     t.isChecked = checkeds.filter((c) => c.code === t.code).length > 0;
  //   });
  // // }, 100);
  // var ClientCode = "";
  // if (Order.value.clientType === "AG") {
  //   ClientCode = Order.value.agencyCode;
  // }
  // if (Order.value.clientType === "DC") {
  //   ClientCode = Order.value.advertiserCode;
  // }
  // if (Order.value.clientType === "P") {
  //   ClientCode = Order.value.advertiserCode;
  // }
  // if ((ClientCode || "") === "") {
  //   visible.value = true;
  //   // popoverRef.value.hide();
  //   return;
  // }
  // //是否有权限
  // if (
  //   isNoSalesAdmin &&
  //   !useOrder.Order.isClientPermission &&
  //   (Order.value.clientType === "P" || Order.value.clientType === "DC")
  // ) {
  //   ElMessage({
  //     message: messageConfig.getMessage("salesPermission"),
  //     type: "warning",
  //   });
  //   visible.value = true;
  //   // popoverRef.value.hide();
  //   return;
  // }
  // 更新样式
};

const changePopCss = () => {
  $('.choose_contact').siblings('.el-popper__arrow').css({
    left: '-245px',
  });

  console.log(
    $('.choose_contact').siblings('.el-popper__arrow').css('left'),
    $('.div-contact-person')
  );
};

const onClickOutside = () => {
  // visible.value = true;
  // unref(popoverRef).popperRef?.delayHide?.();

  // 更新状态
  const checkeds =
    ContactPersons.value
      .filter((t) => t.status !== 'Inactive')
      ?.map((t) => t.code) || [];
  useOrder.ContactOptionalsOld.map((t) => {
    t.isChecked = checkeds.filter((c) => c === t.id).length > 0;
  });
  useOrder.ContactOptionals = useOrder.ContactOptionalsOld;

  var ClientCode = '';
  if (Order.value.clientType === 'AG') {
    ClientCode = Order.value.agencyCode;
  }
  if (Order.value.clientType === 'DC') {
    ClientCode = Order.value.advertiserCode;
  }
  if (Order.value.clientType === 'P') {
    ClientCode = Order.value.advertiserCode;
  }
  if ((ClientCode || '') === '') {
    visible.value = false;
    // popoverRef.value.hide();
    return;
  }

  //是否有权限
  if (
    isSales &&
    !useOrder.Order.isClientPermission &&
    (Order.value.clientType === 'P' || Order.value.clientType === 'DC')
  ) {
    ElMessage({
      message: messageConfig.getMessage('salesPermission'),
      type: 'warning',
    });
    visible.value = false;
    // popoverRef.value.hide();
    return;
  }
  visible.value = true;
};

// 关闭Contact
const closeContact = () => {
  visible.value = false;
  // popoverRef.value.hide();
};

// 批量添加Contact Person
const addContactPersons = async () => {
  closeContact();
};

//保存useOrder.OrderBusinessCategoryIds的旧值
var OrderBusinessCategoryIds_old = [];
// 监听绑定
watch(
  () => useOrder.OrderBusinessCategoryIds,
  (newValue, oldValue) => {
    OrderBusinessCategoryIds_old = oldValue;
  }
);
const changeOrderBusinessCategory = () => {
  //ProductCategory是否已经选择
  if (useOrder.ProductCategoryIds.length > 0) {
    ElMessage({
      message: 'Please remove product category before this action.',
      type: 'warning',
    });
    useOrder.OrderBusinessCategoryIds = OrderBusinessCategoryIds_old;
    return;
  }
  // 更新Business Category
  const arrs =
    useOrder.BusinessCategories.filter(
      (t) => useOrder.OrderBusinessCategoryIds.indexOf(t.businessCategoryId) < 0
    ) || [];

  // 删除
  arrs.forEach((item) => {
    const index = useOrder.BusinessCategories.find(
      (t) => t.businessCategoryId === item.businessCategoryId
    );
    useOrder.BusinessCategories.splice(index, 1);
  });

  const OrderCategoryIds =
    useOrder.BusinessCategories?.length == 0
      ? []
      : useOrder.BusinessCategories.map((t) => t.businessCategoryId);
  const CategoryIds =
    useOrder.OrderBusinessCategoryIds.filter(
      (t) => OrderCategoryIds.indexOf(t) < 0
    ) || [];
  CategoryIds.forEach((item) => {
    const cateogry = useOrder.BusinessOptions.find((t) => t.id === item);
    useOrder.BusinessCategories.push({
      id: 0,
      businessCategoryId: item,
      code: cateogry.code,
      name: cateogry.name,
      status: 'Active',
    });
  });
};

const CategoryBlur = () => {
  if (!$('.category input').is(':focus') && CategoryRef.value.dropMenuVisible) {
    $('.category input').focus();
  }
};

const ContactPersonWidth = () => {
  return document.getElementsByClassName('card-contact-person')?.[0]
    ?.clientWidth;
};

// #endregion
//跳转CRM,company
const linkToCompany = async () => {
  window.open(crmUrl.value + '/#/crm/company', '_blank');
};
//跳转CRM,Contact
const linkToContact = async () => {
  window.open(crmUrl.value + '/#/crm/contact', '_blank');
};
</script>

<style scoped>
.ctrParty {
  padding: 0 20px;
}

.el-select {
  width: 100%;
}

.choose_contact {
  width: 750px;
}

.operation-icon.el-button--text:focus,
.operation-icon.el-button--text:hover {
  color: #f56c6c;
  border-color: transparent;
  background-color: transparent;
}

.br {
  padding-left: 3px;
}

.expired {
  min-width: 40px;
}

.row-item {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 15px;
}

.cell-1 {
  width: 65%;
  padding-right: 10px;
}

.cell-2 {
  width: 15%;
  padding-right: 10px;
}

.cell-3 {
  width: 15%;
}
</style>
<style>
.com-body .com-body-item .el-row:last-child {
  padding-bottom: 0px;
}

.agency-messagebox {
  width: 434px !important;
}

.contracting-party .form-group.has-label label:after {
  content: '【 Contracting Party 】';
  color: #d05c5f;
}

.address .el-textarea__inner {
  padding-left: 15px;
}
</style>
<style scoped>
.new-order h4 {
  color: #3b291d;
}

.new-order h5 {
  color: #423022;
}

.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}

.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}

.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.Rectangle {
  width: 160px;
  height: 32px;
  margin: 20px 1474.6px 0 0;
  padding: 6px 15px 6px 58px;
  border-radius: 6px;
  background-image: linear-gradient(to left, #eb6100, #b60005);
  color: #fff;
}

.icon-user-add {
  width: 16.5px;
  height: 16.9px;
  margin: 0px 4.6px 0.1px 0;
  object-fit: contain;
}
</style>
